export const loginButton = {
  fontFamily: 'Poppins, sans-serif',
  width: '100%',
  backgroundColor: 'var(--accent)',
  color: 'var(--text-on-primary)',
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: '400',
  textTransform: 'none',
  borderRadius: '12px',
  padding: '14px 32px 14px 32px',
  marginBottom: '24px',
  '&:hover': {
    backgroundColor: 'var(--primary-hover)',
  },
};

export const forgotPasswordBackButton = {
  fontFamily: 'Poppins, sans-serif',
  textTransform: 'capitalize',
  color: 'var(--primary)',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '16px',
  '&:hover': {
    backgroundColor: 'transparent',
  },
};

export const createButton = {
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '16px',
  borderRadius: '12px',
  padding: '12px 24px 12px 24px',
  border: '1px solid var(--accent)',
  background: 'var(--accent)',
  color: 'var(--text-on-primary)',
  boxShadow: 'none',
  textTransform: 'capitalize',
  '&:hover': {
    background: 'var(--primary-hover)',
    boxShadow: 'none',
  },
};

export const createButtonModal = {
  fontFamily: 'Poppins, sans-serif',
  backgroundColor: 'var(--accent)',
  borderRadius: '12px',
  padding: '12px 24px 12px 24px',
  fontWeight: 400,
  lineHeight: '16px',
  fontSize: '14px',
  color: 'var(--text-on-primary)',
  textTransform: 'capitalize',
  '&:hover': {
    backgroundColor: 'var(--primary-hover)',
  },
  '&:disabled': {
    backgroundColor: 'var(--primary-hover)',
    color: '94979B',
  },
};
export const disabledCreateButtonModal = {
  fontFamily: 'Poppins, sans-serif',
  backgroundColor: 'var(--disabled-bg)',
  borderRadius: '12px',
  padding: '12px 24px 12px 24px',
  fontWeight: 400,
  lineHeight: '16px',
  fontSize: '14px',
  color: 'var(--text-secondary)',
  textTransform: 'capitalize',
};

export const deleteButtonModal = {
  fontFamily: 'Poppins, sans-serif',
  backgroundColor: 'var(--accent)',
  borderRadius: '12px',
  padding: '12px 24px 12px 24px',
  fontWeight: 400,
  lineHeight: '16px',
  fontSize: '14px',
  color: 'var(--text-on-primary)',
  textTransform: 'capitalize',
  '&:hover': {
    backgroundColor: 'var(--primary-hover)',
  },
};

export const cancelButton = {
  fontFamily: 'Poppins, sans-serif',
  border: '1px solid var(--primary)',
  padding: '11px 24px 11px 24px',
  borderRadius: '12px',
  color: 'var(--primary)',
  lineHeight: '16px',
  fontWeight: '400',
  textTransform: 'capitalize',
  fontSize: '14px',
  backgroundColor: 'var(--bg-surface)',
  '&:hover': {
    backgroundColor: 'var(--bg-subtle)',
  },
};

export const editDealerButton = {
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '16px',
  borderRadius: '12px',
  padding: '12px 24px 12px 24px',
  border: '1px solid var(--accent)',
  background: 'var(--accent)',
  color: 'var(--text-on-primary)',
  boxShadow: 'none',
  textTransform: 'capitalize',
  '& svg': {
    width: '16px',
    height: '16px',
    filter:
      'invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%)',
  },
  '&:hover': {
    background: 'var(--primary-hover)',
    boxShadow: 'none',
  },
};

export const resetPasswordButtonModal = {
  fontFamily: 'Poppins, sans-serif',
  backgroundColor: 'var(--accent)',
  borderRadius: '12px',
  padding: '12px 24px 12px 24px',
  fontWeight: 400,
  lineHeight: '16px',
  fontSize: '14px',
  color: 'var(--text-on-primary)',
  textTransform: 'capitalize',
  '&:hover': {
    backgroundColor: 'var(--primary-hover)',
  },
};

export const recoverButtonModal = {
  fontFamily: 'Poppins, sans-serif',
  backgroundColor: 'var(--accent)',
  borderRadius: '12px',
  padding: '12px 24px 12px 24px',
  fontWeight: 400,
  lineHeight: '16px',
  fontSize: '14px',
  color: 'var(--text-on-primary)',
  textTransform: 'capitalize',
  '&:hover': {
    backgroundColor: 'var(--primary-hover)',
  },
};

export const warningModalButton = {
  fontFamily: 'Poppins, sans-serif',
  backgroundColor: 'var(--accent)',
  borderRadius: '12px',
  padding: '12px 24px 12px 24px',
  fontWeight: 400,
  lineHeight: '16px',
  fontSize: '14px',
  color: 'var(--text-on-primary)',
  textTransform: 'capitalize',
  '&:hover': {
    backgroundColor: 'var(--primary-hover)',
  },
};

export const goBackButton = {
  fontFamily: 'Poppins, sans-serif',
  color: 'var(--primary)',
  borderRadius: '12px',
  border: '1px solid var(--primary)',
  padding: '12px 24px 12px 24px',
  background: 'var(--bg-surface)',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: '400',
  gap: '6px',
  textTransform: 'capitalize',
  '&:hover': {
    backgroundColor: 'var(--bg-subtle)',
  },
};

export const createTaskBackupButtons = {
  fontFamily: 'Poppins, sans-serif',
  color: 'var(--primary)',
  lineHeight: '20px',
  fontSize: '20px',
  fontWeight: '500',
  background: 'var(--bg-surface)',
  borderRadius: '12px',
  minWidth: '40px',
  minHeight: '40px',
  border: '1px solid var(--border)',
  '&:hover': {
    background: 'var(--bg-surface)',
  },
};

export const createTaskBackupButtonsDisabled = {
  ...createTaskBackupButtons,
  background: 'var(--disabled-bg)',
};

export const addDirectoryButton = {
  backgroundColor: 'var(--accent)',
  color: 'var(--text-on-primary)',
  borderRadius: '12px',
  minWidth: '40px',
  minHeight: '40px',
  '&:hover': {
    backgroundColor: 'var(--accent)',
  },
};

export const createButtonOutlinedWithoutLoading = {
  fontFamily: 'Poppins, sans-serif',
  color: 'var(--primary)',
  borderRadius: '12px',
  border: '1px solid var(--primary)',
  padding: '12px 24px 12px 24px',
  background: 'var(--bg-surface)',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: '400',
  gap: '6px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'var(--bg-subtle)',
  },
};

export const createTaskButtonOutlinedWithoutLoading = {
  fontFamily: 'Poppins, sans-serif',
  color: 'var(--text-on-primary)',
  borderRadius: '12px',
  border: '1px solid var(--primary)',
  padding: '12px 24px 12px 24px',
  background: 'var(--accent)',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: '400',
  gap: '6px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'var(--primary-hover)',
  },
};

export const clearFiltersButton = {
  fontFamily: 'Poppins, sans-serif',
  borderRadius: '12px',
  padding: '10px 0 10px 0',
  color: 'var(--primary)',
  border: '1px solid var(--primary)',
  lineHeight: '16px',
  fontSize: '14px',
  fontWeight: '400',
  textTransform: 'none',
  flexGrow: '1',
};

export const addBranchInEdit = {
  fontFamily: 'Poppins, sans-serif',
  fontWeight: '400',
  color: 'var(--primary)',
  lineHeight: '16px',
  fontSize: '14px',
  textTransform: 'none',
  marginBottom: '16px',
  '& svg': {
    filter:
      'invert(27%) sepia(86%) saturate(1209%) hue-rotate(208deg) brightness(94%) contrast(102%)',
  },
};
